import React from 'react';
import { withAsyncActions } from 'react-async-client';

import { DefinitionField } from 'components/common/fields/DefinitionField';
import { getApprovalPerson } from 'actions/asyncActions';
import ApprovalLetter from 'components/sidebars/approvals/ApprovalLetter';
import { fullAutoOptions } from 'constants/asyncClient';
import ApprovalPersonGeneral from 'components/sidebars/approvals/person/fields/ApprovalPersonGeneral';
import { getFullName } from 'helpers/fieldsHelpers';
import ErrorHTML from 'components/common/form/ErrorHTML';

const EmailApprovalPerson = ({ getApprovalPerson: { data : person, meta }, form }) => (
    <div>
        <ErrorHTML meta={meta} />
        { meta.success &&
            <div>
                <div className="email-fields">
                    <DefinitionField translate="approvalProject.headers.date" text={person.date} />
                    <DefinitionField translate="approvalProject.headers.sender" text={person.senderName} />
                    <DefinitionField translate="person.fullName" text={getFullName(person)} />
                    <DefinitionField translate="project.headers.posname" text={person.projectName} />
                    <DefinitionField translate="project.headers.responsible" text={person.responsibleName} />
                    <DefinitionField translate="approvalProject.approval_type" text={person.typeName} />
                    <ApprovalPersonGeneral person={person} />
                </div>
                <ApprovalLetter letter={person.letter} />
                { form }
            </div>
        }
    </div>
);

export default withAsyncActions({
    getApprovalPerson: getApprovalPerson
        .withPayload(({ token }) => ({ token, id: 0 }))
        .withOptions(fullAutoOptions)
})(EmailApprovalPerson);
